import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = { class: "caption" }
const _hoisted_3 = { class: "h2 mt-s1" }


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogHeader',
  props: {
    action: null,
    portfolioName: null
  },
  setup(__props: any) {

const props = __props as {
  action: string;
  portfolioName: string;
}

// eslint-disable-next-line no-unused-vars
// @ts-ignore


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.action)), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.portfolioName), 1)
    ])
  ]))
}
}

})